import styled from 'styled-components'

export const ModalTitle = styled.h2`
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
`

export const ModalText = styled.p`
  font-size: 18px;
  text-align: center;
  margin-bottom: 24px;
  line-height: 30px;
  padding: 0 36px;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const BaseButton = styled.button`
  padding: 16px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
`

export const AcceptButton = styled(BaseButton)`
  background-color: #c00078;
  color: white;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  max-width: 700px;
`
